import { render, staticRenderFns } from "./ExtractStatisticsIndex.vue?vue&type=template&id=5da1cd89&scoped=true"
import script from "./ExtractStatisticsIndex.vue?vue&type=script&lang=js"
export * from "./ExtractStatisticsIndex.vue?vue&type=script&lang=js"
import style0 from "./ExtractStatisticsIndex.vue?vue&type=style&index=0&id=5da1cd89&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1cd89",
  null
  
)

export default component.exports